import axios from 'axios'

const mail_history_form = {
  namespaced: true,

  state() {
    return {
      data: {
        id: null,
        subject: null,
        body: null,
        user_id: null,
        mailed_at: null,
        is_read: false,
      },
      errors: {},
    };
  },
  mutations: {
    setData(state, data) {
      state.data.id = data.id;
      state.data.subject = data.subject;
      state.data.body = data.body;
      state.data.user_id = data.user_id;
      state.data.mailed_at = data.mailed_at;
      state.data.is_read = data.is_read;
      state.errors = {};
    },
    resetData(state) {
      state.data.id = null;
      state.data.subject = null;
      state.data.body = null;
      state.data.user_id = null;
      state.data.mailed_at = null;
      state.data.is_read = false;
      state.errors = {};
    },
    resetErrors(state) {
      state.errors = {};
    },
  },
  actions: {
    updateIsRead({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.put(`/api/mail_histories/${payload.id}`, 
          {is_read: payload.is_read}
        ).then(() => {
          commit('resetErrors');
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({ handled });
        });
      });
    },
  }
};

export default mail_history_form;
